module.exports = __webpack_public_path__ + "static/media/IE4@2x.53fd53f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/IE/IE4@2x.png
// module id = 659
// module chunks = 0